import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {FaceSDK} from "@identy/identy-face";

if (environment.production) {
  enableProdMode();
}

// ******************************* //
// Preinitialize (Face-Only SDK) //
// ******************************* //

const modelUrl = {
    URL: `${environment.url_models}/api/v1/face/models`
};
const pubKeyUrl = {
    URL: {
      url: `${environment.url_pub_key}/api/v1/pub_key`,
      headers: [{
        name: "LogAPITrigger",
        value: "true"
      },
        {
          name: "requestID",
          value: "<REPLACE_BY_A_UNIQUE_SESSION_ID>"
        }]
    }
};
const timeUrl = {
    URL : `${environment.url_processing}/api/v1/time`
};

// Face-Only SDK — no VideoSelfie support
FaceSDK.preInitialize(modelUrl, pubKeyUrl, timeUrl);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';

    // @ts-ignore
    if (search instanceof RegExp) {
      throw TypeError('first argument must not be a RegExp');
    }
    if (start === undefined) { start = 0; }
    return this.indexOf(search, start) !== -1;
  };
}
